export const WIDGETS = {
  NEWS_FEED: 'NEWS_FEED',
  MY_SCHEDULE: 'MY_SCHEDULE',
  SCHEDULE: 'SCHEDULE',
  SEARCH_REDIRECT: 'SEARCH_REDIRECT',
  CALENDAR: 'CALENDAR',
  RECENTLY_ADDED_KNOWLEDGE: 'RECENTLY_ADDED_KNOWLEDGE',
  RECENTLY_UPDATED_KNOWLEDGE: 'RECENTLY_UPDATED_KNOWLEDGE',
  MOST_VIEWED_KNOWLEDGE: 'MOST_VIEWED_KNOWLEDGE',
  MOST_VIEWED_KNOWLEDGE_BY_ME: 'MOST_VIEWED_KNOWLEDGE_BY_ME',
  ROTATIONS: 'ROTATIONS',
  QUICK_LINKS: 'QUICK_LINKS',
  QUALITY_METRICS: 'QUALITY_METRICS',
  CONTENT_SHORTCUTS: 'CONTENT_SHORTCUTS',
};

export const DEFAULT_WIDGET_ORDER = [
  WIDGETS.SEARCH_REDIRECT,
  WIDGETS.CONTENT_SHORTCUTS,
  WIDGETS.MY_SCHEDULE,
  WIDGETS.QUALITY_METRICS,
  WIDGETS.QUICK_LINKS,
  WIDGETS.ROTATIONS,
  WIDGETS.SCHEDULE,
  WIDGETS.CALENDAR,
  WIDGETS.NEWS_FEED,
  WIDGETS.RECENTLY_ADDED_KNOWLEDGE,
  WIDGETS.RECENTLY_UPDATED_KNOWLEDGE,
  WIDGETS.MOST_VIEWED_KNOWLEDGE,
  WIDGETS.MOST_VIEWED_KNOWLEDGE_BY_ME,
];
